import routeHandler from './routes';
import MODULE_ID from './moduleId';

const module = {
    moduleType: 'Telemetrie',
    api: 'telemetrie',
    path: 'telemetrie',
    moduleId: MODULE_ID,
    routeHandler,
};
export default module;